// Removed unused getAPIBaseURL import (service builds its own base URL)

const { safeFetch, tokenStore } = require('../utils/security');

const fileUploadService = {
  _getAPIBaseURL: () => {
    const isDevelopment = process.env.NODE_ENV === 'development';
    
    if (process.env.REACT_APP_API_URL) {
      const apiUrl = process.env.REACT_APP_API_URL;
      return apiUrl.endsWith('/api') ? apiUrl : `${apiUrl}/api`;
    }
    
    if (isDevelopment) {
      return 'http://localhost:8080/api';
    }
    
    return '/api';
  },

  validateFile: (file) => {
    if (!file) {
      return { valid: false, error: 'No file selected' };
    }
    
    if (file.size > 10 * 1024 * 1024) {
      return { valid: false, error: 'File size must be less than 10MB' };
    }
    
    if (!file.type.startsWith('image/')) {
      return { valid: false, error: 'Only image files are allowed' };
    }
    
    const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/webp'];
    if (!allowedTypes.includes(file.type)) {
      return { valid: false, error: 'Unsupported image format. Use JPEG, PNG, GIF, or WebP' };
    }
    
    return { valid: true };
  },

  uploadProductImage: async (file) => {
    const validation = fileUploadService.validateFile(file);
    if (!validation.valid) {
      return {
        success: false,
        error: validation.error,
        message: validation.error
      };
    }

    try {
      const formData = new FormData();
      formData.append('file', file);

  const token = tokenStore.get();
      if (!token) {
        return {
          success: false,
          error: 'Authentication required',
          message: 'Please log in to upload images'
        };
      }

      const response = await safeFetch(`${fileUploadService._getAPIBaseURL()}/files/product-image`, {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}` },
        body: formData
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = response.data || {};
      
      if (data.success) {
  const baseUrl = fileUploadService._getAPIBaseURL();
        return {
          success: true,
          data: { 
            url: `${baseUrl}/assets/products/${data.filename}`,
            filename: data.filename, 
            size: data.size 
          },
          message: data.message
        };
      } else {
        return {
          success: false,
          error: data.error || 'Upload failed',
          message: data.message || 'Failed to upload product image'
        };
      }
    } catch (error) {
      return {
        success: false,
        error: 'Upload failed',
        message: 'Failed to upload product image'
      };
    }
  },

  uploadPostImage: async (file) => {
    const validation = fileUploadService.validateFile(file);
    if (!validation.valid) {
      return {
        success: false,
        error: validation.error,
        message: validation.error
      };
    }

    try {
      const formData = new FormData();
      formData.append('file', file);

  const token = tokenStore.get();
      if (!token) {
        return {
          success: false,
          error: 'Authentication required',
          message: 'Please log in to upload images'
        };
      }

      const response = await safeFetch(`${fileUploadService._getAPIBaseURL()}/files/post-image`, {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}` },
        body: formData
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = response.data || {};
      
      if (data.success) {
  const baseUrl = fileUploadService._getAPIBaseURL();
        return {
          success: true,
          data: { 
            url: `${baseUrl}/assets/posts/${data.filename}`,
            filename: data.filename, 
            size: data.size 
          },
          message: data.message
        };
      } else {
        return {
          success: false,
          error: data.error || 'Upload failed',
          message: data.message || 'Failed to upload post image'
        };
      }
    } catch (error) {
      return {
        success: false,
        error: 'Upload failed',
        message: 'Failed to upload post image'
      };
    }
  },

  uploadLogo: async (file) => {
    const validation = fileUploadService.validateFile(file);
    if (!validation.valid) {
      return {
        success: false,
        error: validation.error,
        message: validation.error
      };
    }

    try {
      const formData = new FormData();
      formData.append('file', file);

  const token = tokenStore.get();
      if (!token) {
        return {
          success: false,
          error: 'Authentication required',
          message: 'Please log in to upload images'
        };
      }

      const response = await safeFetch(`${fileUploadService._getAPIBaseURL()}/files/logo`, {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}` },
        body: formData
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = response.data || {};
      
      if (data.success) {
  const baseUrl = fileUploadService._getAPIBaseURL();
        return {
          success: true,
          data: { 
            url: `${baseUrl}/assets/logos/${data.filename}`,
            filename: data.filename, 
            size: data.size 
          },
          message: data.message
        };
      } else {
        return {
          success: false,
          error: data.error || 'Upload failed',
          message: data.message || 'Failed to upload logo'
        };
      }
    } catch (error) {
      return {
        success: false,
        error: 'Upload failed',
        message: 'Failed to upload logo'
      };
    }
  },

  uploadBanner: async (file) => {
    const validation = fileUploadService.validateFile(file);
    if (!validation.valid) {
      return {
        success: false,
        error: validation.error,
        message: validation.error
      };
    }

    try {
      const formData = new FormData();
      formData.append('file', file);

  const token = tokenStore.get();
      if (!token) {
        return {
          success: false,
          error: 'Authentication required',
          message: 'Please log in to upload images'
        };
      }

      const response = await safeFetch(`${fileUploadService._getAPIBaseURL()}/files/banner`, {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}` },
        body: formData
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = response.data || {};
      
      if (data.success) {
  const baseUrl = fileUploadService._getAPIBaseURL();
        return {
          success: true,
          data: { 
            url: `${baseUrl}/assets/banners/${data.filename}`,
            filename: data.filename, 
            size: data.size 
          },
          message: data.message
        };
      } else {
        return {
          success: false,
          error: data.error || 'Upload failed',
          message: data.message || 'Failed to upload banner'
        };
      }
    } catch (error) {
      return {
        success: false,
        error: 'Upload failed',
        message: 'Failed to upload banner'
      };
    }
  },

  uploadFavicon: async (file) => {
    const validation = fileUploadService.validateFile(file);
    if (!validation.valid) {
      return {
        success: false,
        error: validation.error,
        message: validation.error
      };
    }

    try {
      const formData = new FormData();
      formData.append('file', file);

  const token = tokenStore.get();
      if (!token) {
        return {
          success: false,
          error: 'Authentication required',
          message: 'Please log in to upload images'
        };
      }

      const response = await safeFetch(`${fileUploadService._getAPIBaseURL()}/files/favicon`, {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}` },
        body: formData
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = response.data || {};
      
      if (data.success) {
  const baseUrl = fileUploadService._getAPIBaseURL();
        return {
          success: true,
          data: { 
            url: `${baseUrl}/assets/favicons/${data.filename}`,
            filename: data.filename, 
            size: data.size 
          },
          message: data.message
        };
      } else {
        return {
          success: false,
          error: data.error || 'Upload failed',
          message: data.message || 'Failed to upload favicon'
        };
      }
    } catch (error) {
      return {
        success: false,
        error: 'Upload failed',
        message: 'Failed to upload favicon'
      };
    }
  },
};

export default fileUploadService; 